import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import ViewModel from '../ViewModel'

const validationSchema = Yup.object({
	width: Yup.number()
		.required('Width is required')
		.positive('Width must be a positive number')
		.min(1, 'Width must be at least 1 cm'),
	length: Yup.number()
		.required('Length is required')
		.positive('Length must be a positive number')
		.min(1, 'Length must be at least 1 cm'),
	height: Yup.number()
		.required('Height is required')
		.positive('Height must be a positive number')
		.min(1, 'Height must be at least 1 cm'),
	weight: Yup.number()
		.required('Weight is required')
		.positive('Weight must be a positive number')
		.min(1, 'Weight must be at least 1 kg'),
})

const Delivery: React.FC = () => {
	const { showDeliveryVariant, isClickDeliveryVairiant } = ViewModel()

	const formik = useFormik({
		initialValues: {
			width: '',
			length: '',
			height: '',
			weight: '',
		},
		validationSchema,
		onSubmit: values => {
			console.log('Form data:', values)
		},
	})
	return (
		<div className="card border border-kumopack-grey-200">
			<div className="card-header border-0 mt-4">
				<div className="card-title">
					{/* Title */}
					<div>
						<h4 className="text-kumopack-grey-900 fw-bold mb-2">4. การจัดส่งสินค้า</h4>
						<div className="text-kumopack-grey-600 fs-6">ไซส์ กล่อง น้ำหนัก</div>
					</div>
				</div>
				<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
			</div>

			<div className={`mb-5 d-flex flex-column flex-xl-row`}>
				<div className="card-body">
					<div className={`mb-5 d-flex flex-column flex-xl-row`}>
						<div className="col-12 col-xl-12">
							<div className="row g-5">
								<div className="col-12 col-xl-3">
									<label className="form-label" htmlFor="flexSwitchCheckDefault">
										ตั้งน้ำหนัก/ขนาด
										<br />
										แยกแต่ละตัวเลือก
									</label>
								</div>
								<div className="col-12 col-xl-9">
									<div className="form-check form-switch">
										<input
											className="form-check-input"
											type="checkbox"
											id="flexSwitchCheckDefault"
											checked={!showDeliveryVariant}
											onChange={isClickDeliveryVairiant}
										/>
									</div>
								</div>
								{!showDeliveryVariant && (
									<div className="row gy-5">
										<label
											className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
											data-testid="form-input-label-component">
											<div className="d-flex flex-column">
												<span>ขนาดกล่องพัสดุ</span>
												<span className="text-kumopack-grey-600 fs-7">(กว้าง x ยาว x สูง)</span>
											</div>
										</label>
										<div className="col-12 col-xl-3">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="shipping-width"
														name="width"
														type="text"
														placeholder="กว้าง"
														className={`form-control ${
															formik.touched.width && formik.errors.width ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.width}
													/>
													<span
														className={`form-unit ${
															formik.touched.width && formik.errors.width ? 'd-none' : ''
														}`}>
														cm
													</span>
													{formik.touched.width && formik.errors.width ? (
														<div className="invalid-feedback">{formik.errors.width}</div>
													) : null}
												</div>
											</form>
										</div>
										<div className="col-12 col-xl-3">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="shipping-length"
														name="length"
														type="text"
														placeholder="ยาว"
														className={`form-control ${
															formik.touched.length && formik.errors.length ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.length}
													/>
													<span
														className={`form-unit ${
															formik.touched.length && formik.errors.length ? 'd-none' : ''
														}`}>
														cm
													</span>
													{formik.touched.length && formik.errors.length ? (
														<div className="invalid-feedback">{formik.errors.length}</div>
													) : null}
												</div>
											</form>
										</div>
										<div className="col-12 col-xl-3">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="shipping-height"
														name="height"
														type="text"
														placeholder="สูง"
														className={`form-control ${
															formik.touched.height && formik.errors.height ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.height}
													/>
													<span
														className={`form-unit ${
															formik.touched.height && formik.errors.height ? 'd-none' : ''
														}`}>
														cm
													</span>
													{formik.touched.height && formik.errors.width ? (
														<div className="invalid-feedback">{formik.errors.height}</div>
													) : null}
												</div>
											</form>
										</div>
										<div className="col-12 col-xl-12">
											<div className="row gy-5">
												<label
													className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
													data-testid="form-input-label-component">
													<div className="d-flex flex-column">
														<span>น้ำหนักพัสดุ</span>
													</div>
												</label>
												<div className="col-12 col-xl-9">
													<form className="mb-5">
														<div
															className={`form-group position-relative ${
																!isMobileDevice() ? 'form-horizontal' : ''
															}`}>
															<input
																id="shipping-weight"
																name="weight"
																type="text"
																placeholder="น้ำหนัก"
																className={`form-control ${
																	formik.touched.weight && formik.errors.weight ? 'is-invalid' : ''
																}`}
																onChange={formik.handleChange}
																onBlur={formik.handleBlur}
																value={formik.values.weight}
															/>
															<span
																className={`form-unit ${
																	formik.touched.weight && formik.errors.weight ? 'd-none' : ''
																}`}>
																kg
															</span>
															{formik.touched.weight && formik.errors.weight ? (
																<div className="invalid-feedback">{formik.errors.weight}</div>
															) : null}
														</div>
													</form>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* <FormGenerator
					formKey="deliveryFee"
					inputType="plain"
					label="ค่าจัดส่ง"
					tooltip="ค่าจัดส่ง"
					containerClassName="mb-5"
					isHorizontal={!isMobileDevice()}
				/> */}
		</div>
	)
}

export default Delivery
